var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$nuxt.isOffline)?_c('div',{staticClass:"offline-tooltip",domProps:{"innerHTML":_vm._s(_vm.$t('you_are_offline'))}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }